module.exports = __webpack_public_path__ + "static/img/2016.04f4643.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2016.png
// module id = 256j
// module chunks = 1